import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";

export default function Impressum() {
  useEffect(() => {
    document.title = "Impressum | ViraAi";
  }, []);
  return (
    <div style={{ backgroundColor: "#0A0A0A", minHeight: "100vh", color: "#F0EDE8", fontFamily: "'Inter', sans-serif" }}>
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[#C9A84C] hover:text-[#E0C375] transition-colors mb-10 text-sm font-medium"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        <h1
          className="text-3xl sm:text-4xl font-black text-[#F0EDE8] mb-8"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Impressum
        </h1>

        <div className="space-y-8 text-[#9A9A9A] text-sm leading-relaxed">
          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">Angaben gemäß § 5 TMG</h2>
            <p>
              Magic Design Agents UG (haftungsbeschränkt)<br />
              Inhaber: Luca Berg<br />
              Bochum, Deutschland
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">Kontakt</h2>
            <p>
              E-Mail: info@viraai.de<br />
              Website: viraai.de
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">Handelsregister</h2>
            <p>
              Registergericht: Amtsgericht Bochum<br />
              Eintragung im Handelsregister in Vorbereitung
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">Umsatzsteuer</h2>
            <p>
              Gemäß § 19 UStG wird keine Umsatzsteuer berechnet<br />
              (Kleinunternehmerregelung)
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">Verantwortlich für den Inhalt (§ 55 Abs. 2 RStV)</h2>
            <p>
              Luca Berg<br />
              Bochum, Deutschland
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#C9A84C] hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              <br /><br />
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
              nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
              Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
